module.exports = __webpack_public_path__ + "static/media/hide.a9870486.svg";